/**
 * PlayIcon/index.js
 * desc: play icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const PlayIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="play icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.play.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 19" xmlns="http://www.w3.org/2000/svg"><path d="M0.208984 1.30512V17.1161C0.209009 17.3044 0.259758 17.4892 0.355865 17.6509C0.451971 17.8127 0.589864 17.9454 0.754962 18.035C0.92006 18.1246 1.10623 18.1678 1.29378 18.16C1.48133 18.1522 1.6633 18.0937 1.82044 17.9907L13.8663 10.0853C14.0111 9.99025 14.1301 9.86053 14.2125 9.70782C14.2948 9.5551 14.3379 9.38421 14.3379 9.21059C14.3379 9.03696 14.2948 8.86607 14.2125 8.71336C14.1301 8.56065 14.0111 8.43093 13.8663 8.33592L1.82044 0.430451C1.6633 0.327443 1.48133 0.268947 1.29378 0.26115C1.10623 0.253353 0.92006 0.296544 0.754962 0.386156C0.589864 0.475768 0.451971 0.608471 0.355865 0.770234C0.259758 0.931996 0.209009 1.11681 0.208984 1.30512Z" /><rect x="14" y="0.683105" width="2" height="17.0545" rx="1"/></svg>
    </IconButton>
);


export default PlayIcon;
